import { useTranslation } from "react-i18next"
import { PaperPlaneTilt } from "@phosphor-icons/react"
import { Tag } from "@/components/ui/tag"
import { TooltipContent, TooltipCustom, TooltipPortal, TooltipTrigger } from "@/components/ui/tooltip"
import { ContactChannel } from "@/types/__generated__/union-types"

interface CommunicationChannelIndicatorProps {
  contactChannel: ContactChannel
  isContactChannelVerified: boolean
}

const CommunicationChannelIndicator = ({
  contactChannel,
  isContactChannelVerified,
}: CommunicationChannelIndicatorProps) => {
  const { t } = useTranslation()
  return (
    <TooltipCustom>
      <TooltipTrigger onClick={(e) => e.preventDefault()}>
        <Tag
          className="ml-1 max-w-[72.5px] lg:max-w-none"
          type={contactChannel === "NO_CHANNEL" ? "critical" : isContactChannelVerified ? "success" : "warning"}
          label={t(`patient.information.contact.${contactChannel}`)}
          icon={<PaperPlaneTilt className="shrink-0" size={16} />}
          visibleTitle={false}
        />
      </TooltipTrigger>
      <TooltipPortal>
        <TooltipContent
          onPointerDownOutside={(e) => e.preventDefault()}
          side="bottom"
          align="center"
          className="mt-1 flex max-w-98 items-center rounded-sm px-1 text-xs leading-4 tracking-wide">
          {t(`patient.information.contact.communicationTooltipList.${contactChannel}`)}
        </TooltipContent>
      </TooltipPortal>
    </TooltipCustom>
  )
}

export { CommunicationChannelIndicator }
